import React from 'react';
import { Box, IconButton, SxProps, Typography } from '@mui/material';
import { mdiClose } from '@mdi/js';
import Icon from '@mdi/react';
import { bodyFont, vars } from '../../../../Theme';
import { useTranslation } from 'react-i18next';
import AppTooltip from '../../AppTooltip/AppTooltip';
import TagChip from '../Workflow/_parts/TagChip';
import { processFileSize } from '../../../../util/FileUtils';
import { InitialReleaseType } from '../../../../redux/project/sliceProjectWorkflow';

const documentRowSx: SxProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
};

const documentInfoSx: SxProps = {
    flexGrow: 4,
    display: 'flex',
    justifyContent: 'space-between',
    pr: '12px',
};

const boxSx: SxProps = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
};

const typographySx: SxProps = {
    ...bodyFont,
    color: vars.font,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 'normal',
};

export default ({ document, removeDocument }: IDocumentRowProps) => {
    const { t } = useTranslation('translations', { keyPrefix: 'dialogParts' });

    return (
        <Box sx={documentRowSx}>
            <Box sx={documentInfoSx}>
                <Box sx={boxSx}>
                    {document.iconProps && (
                        <Icon
                            path={document.iconProps.path}
                            color={document.iconProps.color}
                            size={1.0}
                            style={{ flex: '0 0 auto' }}
                        />
                    )}
                    <Typography sx={typographySx}>{document.title}</Typography>
                </Box>
                <Box sx={boxSx}>
                    {document.size && (
                        <Typography sx={{ ...typographySx, pl: '12px' }} noWrap>
                            {processFileSize(document.size)}
                        </Typography>
                    )}
                    {document.releasetype && <TagChip releaseType={document.releasetype} />}
                </Box>
            </Box>
            {Boolean(document.statusIcon) && document.statusIcon}
            {removeDocument && (
                <AppTooltip title={t('tooltipRemoveFileFromGroup')} placement='top-end'>
                    <IconButton
                        onClick={() => removeDocument(document.universalId)}
                        sx={{ p: 0, width: '24px', borderRadius: '4px' }}
                    >
                        <Icon path={mdiClose} size={1} color={vars.font} />
                    </IconButton>
                </AppTooltip>
            )}
        </Box>
    );
};

export interface IDocumentRowProps {
    document: IRelatedDocument;
    removeDocument?: (documentUniId: string) => void;
}

export interface IRelatedDocument {
    universalId: string;
    title: string;
    size?: number;
    releasetype?: InitialReleaseType;
    iconProps?: {
        path: string;
        color: string;
    };
    statusIcon?: React.ReactNode;
    errorInfo?: string[];
}
